import styled from "styled-components";
import Colors from "assets/Colors.js";

const Container = styled.div`
  min-height: 275px;
  height: 100%;
  padding: 20px 17px;
  min-width: 400px;
  width: 100%;
  width: auto;
  overflow: hidden;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  margin-bottom: 36px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: ${Colors.text_on_primary};
`;

const RoundColor = styled.div`
  position: relative;
  height: 9px;
  width: 9px;
  border-radius: 50%;
  margin-right: 5px;
  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    border: 1px solid ${Colors.text_on_primary};
  }

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`;

const PaymentTypeText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  color: ${Colors.text_on_primary};
`;

const ContainerColorPaymentType = styled.div`
  display: flex;
  align-items: center;
  margin-right: 13px;
`;

const TypesContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  height: 42px;
  margin: -20px -17px;
  padding-left: 17px;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
`;

const ChartContainer = styled.div`
  margin-top: 30px;
  height: 250px;
`;

const NoItemsContainer = styled.div`
  min-height: 220px;
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

export default {
  Container,
  Title,
  RoundColor,
  PaymentTypeText,
  ContainerColorPaymentType,
  TypesContainer,
  HeaderContainer,
  ChartContainer,
  NoItemsContainer,
  NoItemsMessageCenter,
};
